import React, { useEffect, useState } from 'react'
import { fetch_profiles } from '../../common/requests/profile';
import BrowserDatabaseKeys from '../../config/browserDatabaseKeys';
import { useNavigate } from 'react-router-dom';
import { Col, Container, ListGroup, Row } from 'react-bootstrap';


const authenticatedUserToken = BrowserDatabaseKeys?.sessionStorage?.user;

export default function Users() {
  
  const navigate = useNavigate();
  
  const [users, setUsers] = useState(null);

  useEffect(() => {
    fetch_profiles()
    .then((res) => {
      setUsers(res.data?.profiles);
    }).catch((err) => alert("Something went wrong"));
  },[]);

  return (
    <Container className='mt-4'>
      <h3>Users</h3>
      <div style={{ display: 'flex' , justifyContent: 'space-around'}} ><p>Full Name</p><p>Username</p><p>Email</p></div>
      {users ? (
        <ListGroup>
          {users.map((user) => (
            <ListGroup.Item
              key={user?._id}
              action
              onClick={() => navigate(`/edit-profile/${user?._id}`)}
            >
              <Row>
                <Col>{user?.name}</Col>
                <Col className='border-start'>{user?.username}</Col>
                <Col className='border-start'>{user?.email}</Col>
              </Row>
            </ListGroup.Item>
          ))}
        </ListGroup>
      ) : null}
    </Container>
  );
}
